export const APPLICATIONID = process.env.VUE_APP_APPLICATIONID;
export const POLICIES = {
    signInSignUpPolicy: 'B2C_1A_fdnkjdfnk_siupin',
    editProfilePolicy: 'B2C_1_ProfileEditing',
};
export const SCOPE = process.env.VUE_APP_SCOPE;
export const RESPONSETYPE = 'token id_token';
// export const REDIRECTURI = process.env.VUE_APP_REDIRECTURI;
export const REDIRECTURI = process.env.NODE_ENV === 'production' ? `https://${window.location.hostname}/auth/check` : `http://${window.location.hostname}:${window.location.port}/auth/check`;
export const TENANTNAME = process.env.VUE_APP_TENANTNAME;// 'LCPMemberwebAuthDev.onmicrosoft.com';

// Not using an ENV file at present as all environments use the same policy
export const SIGNINSIGNUPPOLICYNAME = 'B2C_1A_fdnkjdfnk_siupin';
export const HELLOJSSIGNINSIGNUPPOLICY = 'adB2CSignInSignUp';
export const EDITPROFILEPOLICYNAME = 'B2C_1_ProfileEditing';
export const HELLOJSEDITPROFILEPOLICY = 'adB2CEditProfile';

export const PASSWORDRESETURL = `https://${TENANTNAME}.b2clogin.com/${TENANTNAME}.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_PR&client_id=${APPLICATIONID}&nonce=defaultNonce&redirect_uri=${REDIRECTURI}&scope=openid&response_type=id_token&prompt=login`;
